import { render, staticRenderFns } from "./FinesList.vue?vue&type=template&id=0b6af177&scoped=true&"
import script from "./FinesList.vue?vue&type=script&lang=js&"
export * from "./FinesList.vue?vue&type=script&lang=js&"
import style0 from "./FinesList.vue?vue&type=style&index=0&id=0b6af177&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6af177",
  null
  
)

export default component.exports